import React from 'react';
import {
  withStyles,
  Divider,
  Grid,
  InputAdornment,
  Tab,
  Tabs,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import EditCustomerMap from '../map/index';
import Select from '../../../../common/StyledSelect';
import { postData, getDataWithQueryString } from '../../../../../api/componentAPIs';
import { withUserProfile } from '../../../../../userProfile/userProfileContext';
import MESSAGES from '../../../../../appMessages';
import { compose } from 'recompose';
import styles from '../styles';
import { withSnackbar } from 'notistack';
import { observer, inject } from 'mobx-react';
import { areIntervalsOverlapping } from 'date-fns';
import { formatAddress } from '../../../Dispatch/utils/utils';
import CustomCheckboxGroupRendered from '../../../Dispatch/RouteExecution/DriverPopUp/common/CheckboxGroup';
import { closedDayTime } from './components/ReceivingHours';
import { AppLoading } from '../../../../../loaders/loaders';
import Events from '../../../../../utilities/EventEmitter';
import { withAppConfig } from '../../../../../appConfigContext';
import WithDrawer from '../../../Dispatch/Common/Drawer/WithDrawer';
import drawConstant from '../../../Settings/common/DrawTools/DrawConstant';
import orderBy from "lodash/orderBy";
import {
  getNoFMEOptions,
  getDeliveryAccessorialList,
  getPickupAccessorialList,
  getNoFMECustomerErrorInfo,
  isDeliveryTab,
  getFormInputValues,
  getDefaultErrorInfo
} from '../utils';
import GeoCodingModal from '../../../Common/Geocoding/GeoCodingModal';
import { getCustomerManagementData } from '../../../Common/Geocoding/utils';
import InfoHeader from './components/InfoHeader';
import DayofWeekHoursInput from './components/DayofWeekHoursInput';
import ReceivingHoursRenderer from './components/ReceivingHoursRenderer';
import appConstants from '../../../../../appConstants';
import Header from './components/Header';
import Action from './components/Action';
import Notes from './components/Notes';
import AppointmentBuffer from "./components/AppointmentBuffer";
import { DAYS, NUMERIC_FIELD_CONFIG, ENABLE_GEOFENCE } from './constant';

@inject("CommonStore")
@observer
class CustomerManagementDialog extends React.Component {
  constructor(props) {
    super(props);
    this.defaultReceivingHours = DAYS.reduce((receivingHours, day) => {
      receivingHours[day] = [""];
      return receivingHours;
    }, {});
    this.state = {
      dataLoaded: false,
      data: null,
      receivingHours: this.defaultReceivingHours,
      address: "",
      selectedRoute: null,
      customerRoutes: [],
      updatePending: false,
      customerGeoFencing: null,
      geoCodeCustomer: null,
      activeTab: this.props.detail || appConstants.CUSTOMER_TYPE.DELIVERY,
      deliveryDetails: {
        errorInfo: getDefaultErrorInfo(),
      },
      pickupDetails: {
        errorInfo: {
          ...getDefaultErrorInfo(),
          noFMECustomer: undefined,
        },
      },
    };
    this.equipmentSizeList = [];
    this.terminalId = this.props.userData.userProfile.terminal.id;
    this.originalGeoFenced = null;
    this.gridHeaderId = "editCustomer";
  }

  componentDidMount() {
    this.props.glEventHub.on(
      `${this.gridHeaderId}_geocode`,
      this.onGeocodeCustomer
    );
    this.getCustomerRoutes();
    this.setTrailerList();
  }

  componentWillUnmount() {
    this.props.glEventHub.off(
      `${this.gridHeaderId}_geocode`,
      this.onGeocodeCustomer
    );
  }

  onGeocodeCustomer = () => {
    this.setState({
      geoCodeCustomer: getCustomerManagementData(
        this.state.data,
        this.state.data?.deliveryDetails?.customerId
          ? appConstants.CUSTOMER_TYPE.DELIVERY
          : appConstants.CUSTOMER_TYPE.PICKUP
      ),
    });
  };

  closeGeocodeModal = (hasGeoDataChanged = false) => {
    if (hasGeoDataChanged) {
      this.getCustomerDetailsData(hasGeoDataChanged);
    }
    this.setState({ geoCodeCustomer: null });
  };

  refreshCustomerData = () => {
    Events.emit("updateCustomerDataByCode", this.state.data);
  };

  getTimeWindow = (openHours, closeHours) => {
    return `${openHours ?? ""} ${closeHours ?? ""}`
      .trim()
      .split(" ")
      .join(" - ");
  };

  getCustomerDetailsData = (hasGeoDataChanged = false) => {
    getDataWithQueryString(
      "GetCustomerDetail",
      `terminalId=${this.terminalId}&customerCodes=${this.props.customerCode}`
    ).then(
      (response) => {
        if (response.status === 200 && response.data.length === 1) {
          const customerData = response.data[0];
          const {
            address,
            address2,
            city,
            state,
            zip,
            isNoFME,
            deliveryDetails,
            pickupDetails,
          } = customerData;
          this.setState((prevState) => ({
            data: customerData,
            address: formatAddress({
              address: `${address} ${address2 ?? ""}`.trim(),
              city,
              state,
              zip,
            }),
            receivingHours: deliveryDetails?.receivingHours
              ? {
                  ...prevState.receivingHours,
                  ...deliveryDetails.receivingHours,
                }
              : null,
            selectedRoute: customerData.deliveryDetails?.route || null,
            pickupDetails: {
              ...this.state.pickupDetails,
              ...pickupDetails,
              defaultHours: this.getTimeWindow(
                pickupDetails?.openHours,
                pickupDetails?.closeHours
              ),
              pickupAccessorialList: getPickupAccessorialList({
                isLiftGateRequired: pickupDetails?.isLiftGateRequired,
                isTrailerSwap: pickupDetails?.isTrailerSwap,
                isNoLg: pickupDetails?.isNoLg,
                featureFlags: {
                  enableNonLGCustomer: this.props.configJSON.enableNonLGCustomer
                },
                isLocal: pickupDetails?.isLocal
              }),
            },
            deliveryDetails: {
              ...this.state.deliveryDetails,
              ...deliveryDetails,
              defaultHours: this.getTimeWindow(
                deliveryDetails?.openHours,
                deliveryDetails?.closeHours
              ),
              deliveryAccessorialList: getDeliveryAccessorialList({
                isLiftGateRequired: deliveryDetails?.isLiftGateRequired,
                isTrailerDrop: deliveryDetails?.isTrailerDrop,
                isNoLg: deliveryDetails?.isNoLg,
                featureFlags: {
                  enableNonLGCustomer: this.props.configJSON.enableNonLGCustomer
                },
                isLocal: deliveryDetails?.isLocal
              }),
              noFMECustomerOptions: getNoFMEOptions(isNoFME),
            },
          }));
          ENABLE_GEOFENCE && this.getCustomerGeoFence(customerData.code);
          hasGeoDataChanged && this.refreshCustomerData();
        } else {
          this.handleGetCustomerDataError();
        }
      },
      (error) => {
        this.handleGetCustomerDataError();
      }
    );
  };

  getCustomerRoutes = () => {
    getDataWithQueryString(
      "GetCustomerRoutes",
      `terminalId=${this.terminalId}`
    ).then(
      (response) => {
        if (response.status === 200 && response.data.length > 0) {
          const customerRoutes = response.data
            .sort((value1, value2) => value1 - value2)
            .map((routeName) => ({ label: routeName, value: routeName }));
          this.setState((prevState) => ({
            customerRoutes,
          }));
        } else {
          this.setState({
            customerRoutes: [],
            selectedRoute: null,
          });
        }
        this.getCustomerDetailsData();
      },
      (error) => {
        this.props.enqueueSnackbar(
          MESSAGES.CUSTOMER_MANAGEMENT.GET_CUSTOMER_ROUTES_FAILURE,
          {
            variant: "error",
          }
        );
        this.setState({
          customerRoutes: [],
          selectedRoute: null,
        });
        this.getCustomerDetailsData();
      }
    );
  };

  getCustomerGeoFence = (customerCode) => {
    getDataWithQueryString(
      "GetCustomerGeoFence",
      `terminalId=${this.terminalId}&customerCode=${customerCode}`
    ).then(
      (response) => {
        if (response?.status === 200) {
          this.originalGeoFenced = response.data[0]?.geoFence || null;
          this.setState(
            {
              customerGeoFencing: response.data[0]?.geoFence || null,
            },
            () => {
              if (response.data[0]?.geoFence) {
                this.selectGeoFenceOnMap(this.state.data.customerId);
              }
            }
          );
        }
      },
      (error) => {
        this.setState({ customerGeoFencing: null });
      }
    );
  };

  selectGeoFenceOnMap = (customerId) => {
    //need some delay to select drawing so added this code
    // it will take some time to load and draw already exist geofencing after that only we can create.
    //we can remove this settime out if we find better solution
    setTimeout(() => {
      Events.emit(
        drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
        [customerId],
        true
      );
    }, 0);
  };

  customerGeoFencingChange = (customerGeoFencing) => {
    if (customerGeoFencing !== this.state.customerGeoFencing) {
      this.setState({
        customerGeoFencing: customerGeoFencing,
      });
      if (customerGeoFencing) {
        this.selectGeoFenceOnMap(this.state.data.customerId);
      }
      this.checkCustomerLocationWithFencing(JSON.parse(customerGeoFencing));
    }
  };

  checkCustomerLocationWithFencing = (customerGeoFencing) => {
    const { data } = this.state;
    const location = data
      ? {
          latitude: data.latitude,
          longitude: data.longitude,
        }
      : null;
    const locationNotWithinGeoFence = !isLocationWithinGeoFence(
      customerGeoFencing,
      location
    );
    if (locationNotWithinGeoFence) {
      this.props.enqueueSnackbar(
        "Customer location should be inside the geofence.",
        {
          variant: "error",
        }
      );
    }
    this.setState({
      updatePending: locationNotWithinGeoFence,
    });
  };

  handleGetCustomerDataError = () => {
    this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.GET_FAILURE, {
      variant: "error",
    });
    this.props.handleClose();
  };

  setTrailerList = () => {
    this.equipmentSizeList = orderBy(
      [
        ...new Set(
          this.props.CommonStore.trailersData.map(
            (trailer) => trailer.trailerLength
          )
        ),
      ].map((trailerLength, index) => ({
        value: index,
        label: trailerLength,
      })),
      "label",
      "desc"
    );
  };

  filterNullableValues = (receivingHours) => {
    return (
      receivingHours &&
      Object.keys(receivingHours).reduce((hours, key) => {
        const prevHours = receivingHours[key];
        hours[key] =
          prevHours.length > 1 ? prevHours.filter(Boolean) : prevHours;
        hours[key] = hours[key].length ? hours[key] : [""];
        return hours;
      }, {})
    );
  };

  cleanData = () => {
    this.setState(
      (prevState) => ({
        receivingHours: this.filterNullableValues(prevState.receivingHours),
        ...(prevState.pickupDetails && {
          pickupDetails: {
            ...prevState.pickupDetails,
            shippingHours: this.filterNullableValues(prevState.pickupDetails.shippingHours),
          },
        }),
      }),
      this.saveCustomerData
    );
  };

  updateCustomerData = () => {
    this.cleanData(this.saveCustomerData);
  };

  getTimeFromWindow = (timeWindow, index) => {
    return Boolean(timeWindow) ? timeWindow.trim().split("-")[index].trim() : "";
  };

  getFormattedAccessorials = (accessorialList) => {
    return accessorialList.reduce(
      (accesorialObject, accesorial) => {
        accesorialObject[accesorial.name] = accesorial.isChecked;
        return accesorialObject;
      },
      {}
    );
  }

  saveCustomerData = () => {
    if (!this.isDataValid()) {
      return;
    }

    const {
      receivingHours,
      selectedRoute,
      deliveryDetails: {
        maxEquipmentSize,
        defaultHours,
        deliveryAccessorialList,
        noFMECustomerOptions,
      },
      pickupDetails: {
        rmaxShipperCode,
        shippingHours = null,
        pickupAccessorialList,
      },
    } = this.state;
    const inputObj = {
      terminalId: this.terminalId,
      deliveryDetails: this.state.data.deliveryDetails
        ? {
            code: this.state.data.code,
            receivingHours: receivingHours,
            openHours: this.getTimeFromWindow(defaultHours, 0),
            closeHours: this.getTimeFromWindow(defaultHours, 1),
            maxEquipmentSize,
            stopTime: this.state.deliveryDetails.stopTime,
            maxDelay: this.state.deliveryDetails.maxDelay,
            moveablePalletCount: this.state.deliveryDetails.moveablePalletCount,
            isAPT: this.state.data.deliveryDetails.isApt, // remove this when APT input is added again
            route: selectedRoute,
            ...(this.props.configJSON.enableFMECustomer && {
              isNoFME: noFMECustomerOptions[0]?.isChecked,
            }),
            ...this.getFormattedAccessorials(deliveryAccessorialList),
            appointmentBufferStart: this.state.deliveryDetails.appointmentBufferStart,
            appointmentBufferEnd: this.state.deliveryDetails.appointmentBufferEnd,
            customerComments: this.state.deliveryDetails.customerComments || null,
          }
        : undefined,
      pickupDetails: this.state.data.pickupDetails
        ? {
            rmaxShipperCode,
            openHours: this.getTimeFromWindow(
              this.state.pickupDetails?.defaultHours,
              0
            ),
            closeHours: this.getTimeFromWindow(
              this.state.pickupDetails?.defaultHours,
              1
            ),
            shippingHours,
            stopTime: this.state.pickupDetails.stopTime,
            maxDelay: this.state.pickupDetails.maxDelay,
            moveablePalletCount: this.state.pickupDetails.moveablePalletCount,
            ...this.getFormattedAccessorials(pickupAccessorialList),
            appointmentBufferStart: this.state.pickupDetails.appointmentBufferStart,
            appointmentBufferEnd: this.state.pickupDetails.appointmentBufferEnd,
            shipperComments: this.state.pickupDetails.shipperComments || null,
          }
        : undefined,
    };
    this.setState({
      updatePending: true,
    });
    postData("UpdateCustomerDetail", inputObj)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.props.enqueueSnackbar(MESSAGES.CUSTOMER_MANAGEMENT.SUCCESS, {
            variant: "success",
          });
          this.setState({
            updatePending: false,
          });
          Events.emit("updateCustomerData", this.props.customerCode);
          Events.emit("RefreshIBStore");
          this.props.handleClose();
        } else {
          this.handleError();
        }
      })
      .catch((err) => {
        this.handleError();
      });
  };

  isDataValid = () => {
    const {
      receivingHours,
      pickupDetails,
      deliveryDetails: { maxEquipmentSize, defaultHours, noFMECustomerOptions },
    } = this.state;
    const deliveryErrorInfo = this.state.deliveryDetails.errorInfo;
     let receivingHoursHasError = false;

    if (this.state.data.deliveryDetails) {
      deliveryErrorInfo.defaultHours = receivingHours?.length
        ? ""
        : this.getDayReceivingHourError([defaultHours])[0];
     
      if (Boolean(receivingHours)) {
        deliveryErrorInfo.receivingHours = this.getreceivingHoursError(
          this.state.receivingHours
        );
        receivingHoursHasError = Boolean(
          Object.keys(deliveryErrorInfo.receivingHours).filter(
            (day) => deliveryErrorInfo.receivingHours[day].filter(Boolean).length
          ).length
        );
      }
      if (this.props.configJSON.enableFMECustomer) {
        deliveryErrorInfo.noFMECustomer = getNoFMECustomerErrorInfo({
          noFMECustomerOptions: noFMECustomerOptions[0]?.isChecked,
          maxEquipmentSize,
        });
      }
    }

    let shippingHoursHasError = false;
    const pickupErrorInfo = this.state.pickupDetails.errorInfo;
    if (this.state.data.pickupDetails) {
      const pickupDefaultHours = this.state.pickupDetails.defaultHours;
      pickupErrorInfo.defaultHours = pickupDefaultHours?.length
        ? ""
        : this.getDayReceivingHourError([pickupDefaultHours])[0];

      if (Boolean(this.state.pickupDetails.shippingHours)) {
        pickupErrorInfo.shippingHours = this.getreceivingHoursError(
          this.state.pickupDetails.shippingHours
        );
        shippingHoursHasError = Boolean(
          Object.keys(pickupErrorInfo.shippingHours).filter(
            (day) => pickupErrorInfo.shippingHours[day].filter(Boolean).length
          ).length
        );
      }
    }
    const deliveryHasError =
      (Boolean(receivingHours)
        ? receivingHoursHasError
        : deliveryErrorInfo.defaultHours) || deliveryErrorInfo.noFMECustomer;
    const pickupHasError = Boolean(pickupDetails?.shippingHours)
      ? shippingHoursHasError
      : pickupErrorInfo.defaultHours;
    const hasError = Boolean(deliveryHasError || pickupHasError);
    let tabToSwitchToOnError = this.state.activeTab;
    if (hasError) {
      tabToSwitchToOnError = deliveryHasError
        ? appConstants.CUSTOMER_TYPE.DELIVERY
        : appConstants.CUSTOMER_TYPE.PICKUP;
    }
    this.setState((state) => ({
      deliveryDetails: {
        ...state.deliveryDetails,
        errorInfo: deliveryErrorInfo,
      },
      pickupDetails: {
        ...state.pickupDetails,
        errorInfo: pickupErrorInfo,
      },
      ...(hasError ? { activeTab: tabToSwitchToOnError } : {}),
    }));
    return !hasError
  };

  handleError = (msg = MESSAGES.CUSTOMER_MANAGEMENT.FAILURE) => {
    this.props.enqueueSnackbar(msg, {
      variant: "error",
    });
    this.setState({
      updatePending: false,
    });
  };

  getreceivingHoursError = (receivingHours) => {
    const receivingHoursError = {};
    Object.keys(receivingHours).forEach((day) => {
      receivingHoursError[day] = this.getDayReceivingHourError(
        receivingHours[day]
      );
    });
    return receivingHoursError;
  };

  getDayReceivingHourError = (receivingHours) => {
    if (receivingHours.filter(Boolean).length < 1) {
      return ["* Required"];
    }
    return receivingHours.filter(Boolean).length === 1
      ? [""]
      : [
          "",
          this.checkIfOverLappingTime(receivingHours[0], receivingHours[1])
            ? "* Time overlapping is not allowed"
            : "",
        ];
  };

  getStartEndTime = (newTime) => {
    const [startTime, endTime] = newTime.split("-");
    const [startHour, startMinute] = startTime.split(":");
    const [endHour, endMinute] = endTime.split(":");
    return {
      start: new Date(0, 0, 0, startHour, startMinute),
      end: new Date(0, 0, 0, endHour, endMinute),
    };
  };

  resetToDefaultHours = () => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    if(isDeliveriesTab){
      this.setState({
        receivingHours: null,
      });
      return;
    }
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: null,
      },
    }));
  };

  checkIfOverLappingTime(firstWindow, secondWindow) {
    return areIntervalsOverlapping(
      this.getStartEndTime(firstWindow),
      this.getStartEndTime(secondWindow)
    );
  }

  updateHours = (day, hours) => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    if(isDeliveriesTab){
      this.setState((prevState) => ({
        receivingHours: {
          ...prevState.receivingHours,
          [day]: hours,
        },
        deliveryDetails: {
          ...prevState.deliveryDetails,
          errorInfo: {
            ...prevState.deliveryDetails.errorInfo,
            receivingHours: {
              ...prevState.deliveryDetails.errorInfo.receivingHours,
              [day]: this.getDayReceivingHourError(hours),
            },
          },
        },
      }));
      return;
    }
  this.updateShippingHours(day,hours);
  };

  updateMaxEquipmentSize = (value) => {
    const maxEquipmentSize = value?.label ?? null;
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        maxEquipmentSize,
        errorInfo: {
          ...prevState.deliveryDetails.errorInfo,
          noFMECustomer: getNoFMECustomerErrorInfo({
            noFMECustomerOptions:
              prevState.deliveryDetails.noFMECustomerOptions[0]?.isChecked,
            maxEquipmentSize,
          }),
        },
      },
    }));
  };

  updateFieldValue =  (fieldName ) => (event) => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    const section = isDeliveriesTab ? "deliveryDetails" : "pickupDetails";
    const fieldValue = event.target.value === "" ? null : Number(event.target.value)  ;
    this.setState((prevState)=>({
      [section]: {
        ...prevState[section],
        [fieldName]: fieldValue,
      },
    }));
  };

  renderNumericField = (fieldKey, value) => {
    const { classes } = this.props;
    const { activeTab } = this.state;
    const config = NUMERIC_FIELD_CONFIG.fields[fieldKey];
    
    if (!config) {
      console.warn(`No configuration found for field: ${fieldKey}`);
      return null;
    }

    const inputProps = {
      inputProps: { max: NUMERIC_FIELD_CONFIG.maxValue },
      className: classes.input,
    };

    if (config.hasUnit) {
      inputProps.endAdornment = (
        <InputAdornment position="end">
          <span className={classes.inputAdornment}>{config.unit}</span>
        </InputAdornment>
      );
    }

    return (
      <TextField
        key={`${activeTab}_${fieldKey}`}
        id="number"
        type="number"
        label={config.label}
        InputProps={inputProps}
        InputLabelProps={{
          classes: {
            root: classes.InputLabelProps,
          },
        }}
        value={value}
        onChange={this.updateFieldValue(fieldKey)}
        variant="outlined"
        autoComplete="off"
        classes={{
          root: classes.textFieldClass,
        }}
      />
    );
  };

  updateRoute = (value) => {
    const selectedRoute = value?.label ?? null;
    const customerRoutes = value?.__isNew__
      ? this.state.customerRoutes
          .filter((option) => !Boolean(option.__isNew__))
          .concat(value)
          .sort((option1, option2) => option1.label - option2.label)
      : this.state.customerRoutes;

    this.setState({
      customerRoutes,
      selectedRoute,
    });
  };

  updateDefaultHours = (day, hours) => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    const fieldName = isDeliveriesTab ? "deliveryDetails" : "pickupDetails";
    const updatedDefaultHours = hours ?? null;
    this.setState((state) => ({
      [fieldName]: {
        ...state[fieldName],
        defaultHours: updatedDefaultHours,
        errorInfo: {
          ...state[fieldName].errorInfo,
          defaultHours: this.getRequiredError(updatedDefaultHours),
        },
      },
    }));
  };

  updateAPTBufferTime = ({appointmentBufferStart, appointmentBufferEnd}) => {
    if(isDeliveryTab(this.state.activeTab)){
      this.setState((prevState) => ({
        deliveryDetails: {
          ...prevState.deliveryDetails,
          appointmentBufferStart,
          appointmentBufferEnd
      }}));
    } else {
      this.setState((prevState) => ({
        pickupDetails: {
          ...prevState.pickupDetails,
          appointmentBufferStart,
          appointmentBufferEnd
      }}));
    }
  }

  getRequiredError = (value = null) => {
    return value !== null ? "" : "* Required";
  };

  getCheckboxIndex = (checkboxOptions, checkBoxName) => {
    return checkboxOptions.findIndex((option) => option.name === checkBoxName);
  };

  getCheckboxIndices = (checkboxOptions) => {
    const indices = {};
    const checkboxNames = checkboxOptions.map(option => option.name);
    checkboxNames.forEach((checkBoxName) => {
        indices[`${checkBoxName}Index`] = this.getCheckboxIndex(checkboxOptions, checkBoxName);
    });
    return indices;
  };

  handleCheckboxToggleForNoLiftGate = (checkboxOptions) => {
    const {
      isNoLgIndex,
      isLiftGateRequiredIndex,
      isTrailerDropIndex,
      isTrailerSwapIndex,
    } = this.getCheckboxIndices(checkboxOptions);

    const isNoLg = checkboxOptions[isNoLgIndex] || {};
    const isLiftGateRequired = checkboxOptions[isLiftGateRequiredIndex] || {};
    if (isNoLg.isChecked && isNoLg.isLastUpdated) {
      checkboxOptions[isLiftGateRequiredIndex].isChecked = false;
    } else if (isNoLg.isLastUpdated) {
      if (isDeliveryTab(this.state.activeTab)) {
        checkboxOptions[isTrailerDropIndex].isChecked = isNoLg.isChecked;
      } else {
        checkboxOptions[isTrailerSwapIndex].isChecked = isNoLg.isChecked;
      }
    } else if (
      isLiftGateRequired.isChecked &&
      isLiftGateRequired.isLastUpdated &&
      isNoLgIndex !== -1
    ) {
      checkboxOptions[isNoLgIndex].isChecked = false;
    }
    this.handleTrailerSwapAndDropConstraints({
      checkboxOptions,
      isLiftGateRequiredIndex,
      isLiftGateRequired,
      isNoLgIndex,
      isTrailerDropIndex,
      isTrailerSwapIndex,
    });
    return checkboxOptions;
  };

  handleTrailerSwapAndDropConstraints = ({
    checkboxOptions,
    isLiftGateRequiredIndex,
    isLiftGateRequired,
    isNoLgIndex,
    isTrailerDropIndex,
    isTrailerSwapIndex,
  }) => {
    if (isDeliveryTab(this.state.activeTab)) {
      const isTrailerDrop = checkboxOptions[isTrailerDropIndex] || {};
      if (isTrailerDrop.isChecked && isTrailerDrop.isLastUpdated) {
        checkboxOptions[isLiftGateRequiredIndex].isChecked = false;
        if (isNoLgIndex !== -1) {
          checkboxOptions[isNoLgIndex].isChecked = isTrailerDrop.isChecked;
        }
      } else if (isLiftGateRequired.isChecked) {
        checkboxOptions[isTrailerDropIndex].isChecked = false;
      }
    } else {
      const isTrailerSwap = checkboxOptions[isTrailerSwapIndex] || {};
      if (isTrailerSwap.isChecked && isTrailerSwap.isLastUpdated) {
        checkboxOptions[isLiftGateRequiredIndex].isChecked = false;
        if (isNoLgIndex !== -1) {
          checkboxOptions[isNoLgIndex].isChecked = isTrailerSwap.isChecked;
        }
      } else if (isLiftGateRequired.isChecked) {
        checkboxOptions[isTrailerSwapIndex].isChecked = false;
      }
    }
    return checkboxOptions;
  }

  updateDeliveryAccessorials = (updatedAccessorials) => {
    this.setState((state) => ({
      deliveryDetails: {
        ...state.deliveryDetails,
        deliveryAccessorialList: this.handleCheckboxToggleForNoLiftGate(updatedAccessorials),
      },
    }));
  };

  updatePickupAccessorials = (updatedAccessorials) => {
    this.setState((state) => ({
      pickupDetails: {
        ...state.pickupDetails,
        pickupAccessorialList: this.handleCheckboxToggleForNoLiftGate(updatedAccessorials),
      },
    }));
  };

  onChangeNoFMECustomer = (noFMECustomerOptions) => {
    this.setState((prevState) => ({
      deliveryDetails: {
        ...prevState.deliveryDetails,
        noFMECustomerOptions,
        errorInfo: {
          ...prevState.deliveryDetails.errorInfo,
          noFMECustomer: getNoFMECustomerErrorInfo({
            noFMECustomerOptions: noFMECustomerOptions[0]?.isChecked,
            maxEquipmentSize: prevState.deliveryDetails.maxEquipmentSize,
          }),
        },
      },
    }));
  };

  markDefaultHoursClosed = () => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    const fieldName = isDeliveriesTab ? "deliveryDetails" : "pickupDetails";
    this.setState((state) => ({
      [fieldName]: {
        ...state[fieldName],
        defaultHours: closedDayTime,
        errorInfo: {
          ...state[fieldName].errorInfo,
          defaultHours: this.getRequiredError(closedDayTime),
        },
      },
    }));
  };

  addDayOfWeekHours = () => {
    const isDeliveriesTab = isDeliveryTab(this.state.activeTab);
    if(isDeliveriesTab){
      this.setState({
        receivingHours: DAYS.reduce((receivingHours, day) => {
          receivingHours[day] = [this.state.deliveryDetails.defaultHours];
          return receivingHours;
        }, {}),
      });
      return;
    }
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: DAYS.reduce((dayShippingHours, day) => {
          dayShippingHours[day] = [this.state.pickupDetails.defaultHours];
          return dayShippingHours;
        }, {}),
      },
    }));
  };

  handleNoteChange = (value) => {
    if (this.state.activeTab === appConstants.CUSTOMER_TYPE.DELIVERY) {
      this.setState((prevState) => ({
        ...prevState,
        deliveryDetails: {
          ...prevState.deliveryDetails,
          customerComments: value,
        },
      }));
      return;
    }
    this.setState((prevState) => ({
      ...prevState,
      pickupDetails: {
        ...prevState.pickupDetails,
        shipperComments: value,
      },
    }));
  };

  renderEditForm = () => {
    const { classes } = this.props;
    const {
      selectedRoute,
      activeTab,
      deliveryDetails: { maxEquipmentSize, deliveryAccessorialList },
      pickupDetails: { pickupAccessorialList },
    } = this.state;
    const isDeliveriesTabActive = isDeliveryTab(activeTab);
    const noDataCondition =
      (isDeliveriesTabActive && !this.state.data.deliveryDetails) ||
      (!isDeliveriesTabActive && !this.state.data.pickupDetails);

    if (noDataCondition) {
      return this.renderNoData();
    }
    const { defaultHours, receivingHours, errorInfo, stopTime ,appointmentBufferStart, appointmentBufferEnd, maxDelay, moveablePalletCount} =
      getFormInputValues(this.state);
    const isDefaultHoursClosed = defaultHours === closedDayTime;
    const hasReceivingHours = Boolean(receivingHours);

    return (
      <Grid item xs={12}>
        <div className={classes.dialogContents}>
          <InfoHeader title="Receiving Hours" />
          <Grid item>
            <DayofWeekHoursInput
              key={`${activeTab}_dayOfWeek`}
              hasHours={hasReceivingHours}
              markDefaultHoursClosed={this.markDefaultHoursClosed}
              isDefaultHoursClosed={isDefaultHoursClosed}
              defaultHoursError={errorInfo?.defaultHours}
              addDayOfWeekHours={this.addDayOfWeekHours}
              updateDefaultHours={this.updateDefaultHours}
              defaultHours={defaultHours}
            />
          </Grid>
          <br />
          <br />
          {hasReceivingHours ? (
            <>
              <ReceivingHoursRenderer
                key={activeTab}
                receivingHours={receivingHours}
                updateHours={this.updateHours}
                errorInfo={errorInfo}
                resetToDefaultHours={this.resetToDefaultHours}
                activeForm={activeTab}
                defaultHours={defaultHours}
              />
              <br />
              <br />
              <Divider className={classes.divider} />
            </>
          ) : null}

          <br />

          <Grid item>
            {activeTab === appConstants.CUSTOMER_TYPE.DELIVERY ? (
              <>
                <CustomCheckboxGroupRendered
                  options={deliveryAccessorialList}
                  onChange={this.updateDeliveryAccessorials}
                />
                {this.props.configJSON.enableFMECustomer && (
                  <CustomCheckboxGroupRendered
                    options={this.state.deliveryDetails.noFMECustomerOptions}
                    onChange={this.onChangeNoFMECustomer}
                  />
                )}
              </>
            ) : (
              <CustomCheckboxGroupRendered
                options={pickupAccessorialList}
                onChange={this.updatePickupAccessorials}
              />
            )}
          </Grid>
          <Grid container>
            {activeTab === appConstants.CUSTOMER_TYPE.DELIVERY && (
              <>
                <Select
                  canAcceptNewValue
                  newValueParams={this.props.configJSON?.routeNameEditParams}
                  textFieldProps={{
                    id: "filterByRoute",
                    label: "Route",
                    variant: "outlined",
                  }}
                  value={selectedRoute}
                  onChange={this.updateRoute}
                  data={this.state.customerRoutes}
                  InputLabelProps={{
                    classes: {
                      root: classes.InputLabelProps,
                    },
                  }}
                  classes={{
                    root: classes.selectFilterClass,
                  }}
                  menuPosition={"fixed"}
                />
                <Select
                  textFieldProps={{
                    id: "filterByEquipmentSize",
                    label: "Max Equip Size",
                    variant: "outlined",
                    helperText: errorInfo.noFMECustomer,
                  }}
                  ref={this.equipRef}
                  value={maxEquipmentSize ?? ""}
                  onChange={this.updateMaxEquipmentSize}
                  data={this.equipmentSizeList}
                  InputLabelProps={{
                    classes: {
                      root: classes.InputLabelProps,
                    },
                  }}
                  classes={{
                    root: classes.selectFilterClass,
                  }}
                  menuPosition="fixed"
                  error={Boolean(errorInfo.noFMECustomer)}
                />
              </>
            )}
           
            {this.renderNumericField('stopTime', stopTime)}
            {this.renderNumericField('maxDelay', maxDelay)}
            {this.renderNumericField('moveablePalletCount', moveablePalletCount)}
          </Grid>

          <Divider className={classes.divider} />
          <AppointmentBuffer
            key={activeTab}
            appointmentBufferStart={appointmentBufferStart}
            appointmentBufferEnd={appointmentBufferEnd}
            onChange={this.updateAPTBufferTime}
          />
          <Divider className={classes.divider} />
          <Grid container>
            <Notes
              key={activeTab}
              value={
                activeTab === appConstants.CUSTOMER_TYPE.DELIVERY
                  ? this.state.deliveryDetails.customerComments
                  : this.state.pickupDetails.shipperComments
              }
              onChange={this.handleNoteChange}
            />
          </Grid>
        </div>
      </Grid>
    );
  };

  renderNoData = () => {
    return (
      <div className={this.props.classes.dialogContent}>
        No details available
      </div>
    );
  };

  updateShippingHours = (day, hours) => {
    this.setState((prevState) => ({
      pickupDetails: {
        ...prevState.pickupDetails,
        shippingHours: {
          ...prevState.pickupDetails.shippingHours,
          [day]: hours,
        },
        errorInfo: {
          ...prevState.pickupDetails.errorInfo,
          shippingHours: {
            ...prevState.pickupDetails.errorInfo.shippingHours,
            [day]: this.getDayReceivingHourError(hours),
          },
        },
      },
    }));
  };

  onChangeTab = (_event, activeTab) => {
    this.setState({
      activeTab,
    });
  };

  getLastModifiedDetails = () => {
    const { data, activeTab } = this.state;
    return activeTab === appConstants.CUSTOMER_TYPE.DELIVERY
      ? data?.deliveryDetails?.lastModified
      : data?.pickupDetails?.lastModified;
  };

  render() {
    const { handleClose, classes, configJSON } = this.props;
    const { data, address, customerGeoFencing } = this.state;
    const { theme } = this.props.userData?.userProfile || {};
    const { dateTime, userName } = this.getLastModifiedDetails() ?? {};
    return (
      <div
        className={`${(classes.dialogWrapper, classes.dialogContainer)} ${
          theme === "dark" ? "darkTheme" : "lightTheme"
        } `}
      >
        {!data ? (
          <AppLoading />
        ) : (
          <>
            <div className={`${classes.formContainer} formStyle`}>
              <Header
                data={data}
                address={address}
                handleClose={handleClose}
                dateTime={dateTime}
                userName={userName}
              />
              <div className={classes.tabContainer}>
                <Tabs
                  value={this.state.activeTab}
                  onChange={this.onChangeTab}
                  textColor="primary"
                  indicatorColor="primary"
                >
                  <Tab
                    label="Deliveries"
                    value={appConstants.CUSTOMER_TYPE.DELIVERY}
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected,
                    }}
                  />
                  {configJSON?.showShippersInCustomerManagement && (
                    <Tab
                      label="Pickups"
                      value={appConstants.CUSTOMER_TYPE.PICKUP}
                      classes={{
                        root: classes.tabRoot,
                        selected: classes.tabSelected,
                      }}
                    />
                  )}
                </Tabs>
              </div>
              <div className={`${classes.dialogContents} customScroll`}>
                {this.renderEditForm()}
              </div>
              <Action
                onClose={handleClose}
                isLoading={this.state.updatePending}
                onClick={this.updateCustomerData}
              />
            </div>
            <div className="mapStyle">
              <EditCustomerMap
                customer={data}
                customerGeoFencing={customerGeoFencing}
                customerGeoFencingChange={this.customerGeoFencingChange}
                glEventHub={this.props.glEventHub}
                gridHeaderId={this.gridHeaderId}
                showGeocodeControl
                enableGeofence={ENABLE_GEOFENCE}
              />
            </div>
            {this.state.geoCodeCustomer && (
              <GeoCodingModal
                customer={this.state.geoCodeCustomer}
                userData={this.props.userData.userProfile}
                close={this.closeGeocodeModal}
              />
            )}
          </>
        )}
      </div>
    );
  }
}

export default compose(
  WithDrawer,
  withStyles(styles),
  withSnackbar,
  withUserProfile,
  withAppConfig
)(CustomerManagementDialog);
